import styled from 'styled-components'

export const TooltipWrapper = styled.div`
    background: ${(props) => props.theme.color.black};
    color: ${(props) => props.theme.color.white};
    padding: 5px 10px;
    ${(props) => props.theme.typo.bodyM}
    border-radius: 10px;
`

export const Label = styled.div`
    ${(props) => props.theme.fontWeight.medium}
`

export const Row = styled.div``
